import './App.css';
import { Box, CssBaseline, ThemeProvider } from '@mui/material';
import Search from './pages/home/Search';
import Theme from './theme/Theme';

function App() {
  return (
    <div className="App">
      <ThemeProvider theme={Theme}>
        <CssBaseline />
        <Box sx={{ display: 'flex', width: '100%' }}>
          <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <Box sx={{ flex: 1, overflow: 'auto' }}>
              <Search />
            </Box>
          </Box>
        </Box>
      </ThemeProvider>
    </div>
  );
}

export default App;
